import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/close.png'


const _withScopeId = n => (_pushScopeId("data-v-fc38c300"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wish-list-wrapper row" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-close-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "icon-close"
  })
], -1))
const _hoisted_4 = { class: "pagination-box" }

import { onMounted } from 'vue';
  import { Collection } from '@/stores';
  import { request } from '@/utils';
  import Item from './components/item.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const variantCollection = Collection.create<Collection>({
    fetch: (params: object) => request.get('bean/variants/follow', { params })
  });

  onMounted(async () => {
    variantCollection.fetchData();
  });

  async function handlePageChange(page: any) {
    variantCollection.params.page = page;
    await variantCollection.fetchData();
  }

return (_ctx: any,_cache: any) => {
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(variantCollection).data.length)
      ? (_openBlock(), _createBlock(_component_AppEmptyView, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(variantCollection).data, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "col-12 col-md-6"
            }, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createVNode(Item, {
                  "variant-id": item.id,
                  "image-url": item.product?.images?.[0]?.url,
                  title: item.name,
                  "primary-text": item.cost_price
                }, null, 8, ["variant-id", "image-url", "title", "primary-text"])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_AppPagination, {
              total: _unref(variantCollection).meta.total,
              "per-page": _unref(variantCollection).meta.per_page,
              page: _unref(variantCollection).meta.page,
              onChange: handlePageChange
            }, null, 8, ["total", "per-page", "page"])
          ])
        ], 64))
  ]))
}
}

})